import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[percentagePromo]'
})
export class PercentagePromoDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: any) {
    let value = this.el.nativeElement.value;

    // Eliminar el contenido si se presiona la tecla "Supr" o "Eliminar"
    if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') {
      this.el.nativeElement.value = '';
      return;
    }

    // Eliminar caracteres no numéricos, excepto el punto y limitar a dos decimales
    value = value.replace(/[^\d.]/g, '');

    const decimalSplit = value.split('.');
    if (decimalSplit.length > 1) {
      decimalSplit[0] = decimalSplit[0].slice(0, 3); // Limitar a tres dígitos en la parte entera (0-100)
      decimalSplit[1] = decimalSplit[1].slice(0, 2); // Limitar a dos decimales
      value = decimalSplit.join('.');
    } else {
      value = value.slice(0, 3); // Limitar a tres dígitos en total si no hay punto decimal
    }

    // Asegurar que el valor esté en el rango de 0 a 100
    const floatValue = parseFloat(value);
    if (isNaN(floatValue) || floatValue < 0) {
      this.el.nativeElement.value = '0';
    } else if (floatValue > 100) {
      this.el.nativeElement.value = '100';
    } else {
      this.el.nativeElement.value = value + ' %';
    }
  }
}
